// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar-uploader>.ant-upload{width:104px;height:104px}.anty-form-btn{width:100%;text-align:center}.anty-form-btn button{margin:0 5px}", ""]);
// Exports
module.exports = exports;
